// extracted by mini-css-extract-plugin
export default {"sectionContainer":"src-pages-SalesCannelVersion-SalesChannelDiscounts-FlashSale-FlashSaleEdit-Attribute-css-module__sectionContainer--ueiQG"};